import React from "react";
import {useNavigate} from "react-router-dom";
import {store} from "../../../redux/store";
import {TRAINING_URL} from "commonUtils/globalAPISettings";

const TrainingViewer: React.FC = () => {
  const navigate = useNavigate();
  React.useEffect(() => {
    const authState = store.getState();
    if (authState.auth?.authDetails?.isAuthenticated) {
      navigate(`/${TRAINING_URL}`);
    } else {
      navigate("/");
    }
  }, []);
  return <></>;
};

export default TrainingViewer;
